document.addEventListener("DOMContentLoaded", function () {
  function initializeDialogs() {
    const dialogOpeners = document.querySelectorAll(
      ".ombraz-v2pdp__dialog-opener"
    );
    let activeDialog = null;

    function openDialog(dialog) {
      dialog.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      const closeButton = dialog.querySelector(".ombraz-v2pdp__dialog-close");
      closeButton.focus();
      activeDialog = dialog;
    }

    function closeDialog(dialog) {
      dialog.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      const opener = document.querySelector(`[data-dialog-id="${dialog.id}"]`);
      opener.focus();
      activeDialog = null;
    }

    function handleEscapeKey(event) {
      if (event.key === "Escape" && activeDialog) {
        closeDialog(activeDialog);
      }
    }

    function trapFocus(event) {
      if (!activeDialog) return;

      const focusableElements = activeDialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const firstElement = focusableElements[0];
      const lastElement = focusableElements[focusableElements.length - 1];

      if (event.key === "Tab") {
        if (event.shiftKey) {
          if (document.activeElement === firstElement) {
            lastElement.focus();
            event.preventDefault();
          }
        } else {
          if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
          }
        }
      }
    }

    dialogOpeners.forEach((opener) => {
      const dialogId = opener.getAttribute("data-dialog-id");
      const dialog = document.getElementById(dialogId);
      if (dialog) {
        const closeButton = dialog.querySelector(".ombraz-v2pdp__dialog-close");
        const overlay = dialog.querySelector(".ombraz-v2pdp__dialog-overlay");

        opener.addEventListener("click", () => openDialog(dialog));
        closeButton.addEventListener("click", () => closeDialog(dialog));
        overlay.addEventListener("click", () => closeDialog(dialog));
      }
    });

    document.addEventListener("keydown", handleEscapeKey);
    document.addEventListener("keydown", trapFocus);
  }

  // Initialize dialogs on page load
  initializeDialogs();
});
